import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { ICrudGetAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './my-favourite.reducer';
import { IMyFavourite } from 'app/shared/model/my-favourite.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IMyFavouriteDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const MyFavouriteDetail = (props: IMyFavouriteDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { myFavouriteEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          MyFavourite [<b>{myFavouriteEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>Video Meta Data</dt>
          <dd>{myFavouriteEntity.videoMetaData ? myFavouriteEntity.videoMetaData.id : ''}</dd>
          <dt>User</dt>
          <dd>{myFavouriteEntity.user ? myFavouriteEntity.user.login : ''}</dd>
        </dl>
        <Button tag={Link} to="/my-favourite" replace color="info">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/my-favourite/${myFavouriteEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ myFavourite }: IRootState) => ({
  myFavouriteEntity: myFavourite.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(MyFavouriteDetail);
